import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

export enum ToggleActions {
  Add = 'add',
}

interface TableActionsProps {
  onActionChange: (action: ToggleActions | null) => void;
  action: ToggleActions | null;
}

export const TableActions = ({ action, onActionChange }: TableActionsProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleActionChange = (_event: React.MouseEvent<HTMLElement>, newAction: ToggleActions | null) => {
    onActionChange(newAction);
  };
  return (
    <ToggleButtonGroup
      value={action}
      exclusive
      onChange={handleActionChange}
      aria-label={t('workflows.actions.title')}
      sx={{
        height: theme.spacing(5),
        '& button': {
          padding: theme.spacing(1),
          width: theme.spacing(5),
        },
      }}
    >
      <ToggleButton value={ToggleActions.Add} aria-label={t('workflows.actions.add')}>
        <AddIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
